import React from 'react';
import { NextSeo } from 'next-seo';
import MainLayout from '@views/layouts/main-layout';
import Recommend from '@views/modules/recommend/dynamic';
import ErrorComponent from '@views/modules/error';

export const Error = ({ statusCode }): JSX.Element => {
  return (
    <MainLayout>
      <NextSeo title="Trang không tồn tại" />
      <ErrorComponent statusCode={statusCode} />
      <Recommend />
    </MainLayout>
  );
};

export default Error;
